import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { ComProductCollectAmountModel } from 'src/app/model/com-product-collect-amount.model';
import { HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { ComProductCollectAmountService } from 'src/oldApp/services/com-product-collect-amount.service';
import { CreatorService } from 'src/app/services/creator.service';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { OtherCatalogsService } from 'src/app/services/other-catalogs.service';
import { VwCommissionConfiguratorService } from 'src/app/services/vw-commission-configurator.service';
import { ModalScProductCollectAmountComponent } from 'src/oldApp/shared/modal-sc-product-collect-amount/modal-sc-product-collect-amount.component';

@Component({
  selector: 'app-sc-product-collect-amount',
  templateUrl: './sc-product-collect-amount.component.html',
  styleUrls: ['./sc-product-collect-amount.component.css']
})
export class ScProductCollectAmountComponent implements OnInit {
  // estado pagina
  public page:string='ScCategoryPromoter';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public items:ComProductCollectAmountModel[]=[];

  // catalogos
  public businessLineCatalog:HMGenericCatalog[]=[];
  public productCOECatalog:HMGenericCatalog[]=[];
  public dealerCatalog:CatalogModel[]=[];
  public paymentTypeCatalog:CatalogModel[]=[];
  public employeeJobCatalog:CatEmployeeJobModel[]=[];
  public collectAmountGroupCatalog:any=[
    {id:1, description:'Grupo 1'},
    {id:2, description:'Grupo 2'}
  ];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private productCollectService:ComProductCollectAmountService,
    private vwCommissionConfiguratorService:VwCommissionConfiguratorService,
    private hypermatrixCatalogsService:HypermatrixCatalogsService,
    private employeeJobService:CatEmployeeJobService,
    private creator:CreatorService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  add=()=> {
    let commission=this.creator.newComProductCollectAmountModel();
    let modalRef=this.modalService.open(ModalScProductCollectAmountComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.commission=commission;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(commission:ComProductCollectAmountModel)=> {
    let modalRef=this.modalService.open(ModalScProductCollectAmountComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.commission={...commission};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // HELPERS
  businessLine=item=> this.businessLineCatalog.find(bl=> bl.idCatalogType===item.businessProductId).description;
  product=item=> this.productCOECatalog.find(pro=> pro.idCatalogType===item.productosCOEId).description;
  dealer=item=> this.dealerCatalog.find(dealer=> dealer.id===item.dealerId)?this.dealerCatalog.find(dealer=> dealer.id===item.dealerId).description:'NO ENCONTRADO!';
  payment=item=> this.paymentTypeCatalog.find(pay=> pay.id===item.paymentId)?this.paymentTypeCatalog.find(pay=> pay.id===item.paymentId).description:'NO ENCONTRADO!';
  employeeJob=item=> this.employeeJobCatalog.find(job=> job.employeeJobId===item.employeeJobId).description;
  group=item=> this.collectAmountGroupCatalog.find(group=> group.id===item.collectAmountGroupId).description;

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.productCollectService.getAll(),
      this.hypermatrixCatalogsService.getCatalog('BusinessProductType'),
      this.hypermatrixCatalogsService.getCatalog('ProductosCOE'),
      this.vwCommissionConfiguratorService.getAfiliates(),
      this.vwCommissionConfiguratorService.getPayments(),
      this.employeeJobService.getAll()
    )
    .pipe(
      tap(([itemsResp, blResp, prodResp, dealerResp, payResp, empJobResp]:[any, any, any, any, any, any])=> {
        if(itemsResp && blResp && prodResp && dealerResp && payResp && empJobResp) {
          this.items=itemsResp.data;
          this.businessLineCatalog=blResp.data,
          this.productCOECatalog=prodResp.data;
          this.dealerCatalog=dealerResp.data;
          this.paymentTypeCatalog=payResp.data;
          this.employeeJobCatalog=empJobResp.data;
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer catálogos.'))
      })
    )
    .subscribe();
  }
}
